import type { Verdict } from '../types'

const R = 72
const CX = 108
const CY = 94
/** The dial is a 270° arc, so three quarters of the circumference. */
const ARC_LENGTH = 2 * Math.PI * R * 0.75

const STROKE: Record<Verdict, string> = {
  comfortable: 'var(--color-green)',
  workable: 'var(--color-gold)',
  tight: 'var(--color-gold)',
  short: 'var(--color-red)',
}

export function CoverageGauge({ coverage, verdict }: { coverage: number; verdict: Verdict }) {
  const filled = ARC_LENGTH * Math.min(Math.max(isFinite(coverage) ? coverage : 1, 0), 1)
  const label = !isFinite(coverage) ? '∞' : coverage >= 10 ? '999%' : `${Math.round(coverage * 100)}%`
  const caption = !isFinite(coverage) ? 'no gap to fund' : 'covered'

  return (
    <div className="relative">
      <svg
        viewBox="0 0 216 152"
        className="mx-auto block w-full max-w-55"
        role="img"
        aria-label={`${label} ${caption}`}
      >
        <g transform={`rotate(135 ${CX} ${CY})`}>
          <circle
            cx={CX}
            cy={CY}
            r={R}
            fill="none"
            stroke="currentColor"
            strokeWidth="9"
            strokeLinecap="round"
            strokeDasharray={`${ARC_LENGTH} ${2 * Math.PI * R}`}
            className="text-white/15"
          />
          <circle
            cx={CX}
            cy={CY}
            r={R}
            fill="none"
            stroke={STROKE[verdict]}
            strokeWidth="9"
            strokeLinecap="round"
            strokeDasharray={`${filled} 999`}
          />
        </g>
      </svg>
      <div className="pointer-events-none absolute inset-x-0 top-1/2 -translate-y-1/2 text-center">
        <p className="text-title-lg font-semibold tabular-nums" style={{ color: STROKE[verdict] }}>
          {label}
        </p>
        <p className="text-body-xs text-white/60 uppercase">{caption}</p>
      </div>
    </div>
  )
}
